"use client";

import UserInfo from "@/app/types/UserInfo";
import MobileMenuAccountHeader from "./MobileMenuAccountHeader";
import MobileMenuItems from "./MobileMenuItems";
import clsMerge from "@/app/util/clsMerge";
import MobileMenuDecoration from "../../../../public/mobileMenuDecoration.svg";
import {MenuItem} from "./MenuTypes";
import Campus from "@/app/types/Campus";
import NavLocation from "../NavLocation";
import HamburgerSignOutButton from "../HamburgerSignOutButton";
import HamburgerSignInButton from "../HamburgerSignInButton";

type MobileMenuProps = {
	userInfo: UserInfo | null;
	campusData: Campus | null;
	menuItems: MenuItem[];
};

const MobileMenu: React.FC<MobileMenuProps> = ({
	userInfo,
	campusData,
	menuItems,
}) => {
	return (
		<div className="relative h-dvh max-h-full w-96 max-w-[100vw] bg-green-800 text-white md:w-[45rem]">
			<MobileMenuDecoration className="absolute bottom-0 left-0" />
			<div className="absolute flex h-full w-full flex-col overflow-auto">
				{userInfo && <MobileMenuAccountHeader {...userInfo} />}
				<div
					className={clsMerge(
						"flex flex-grow flex-col gap-6 px-4 py-6 pt-4",
						!userInfo && "pt-16"
					)}
				>
					<MobileMenuItems
						className="flex-grow"
						menuLabel="Main Menu"
						items={menuItems}
					/>
					{campusData && <NavLocation data={campusData} />}
					{userInfo ? <HamburgerSignOutButton /> : <HamburgerSignInButton />}
				</div>
			</div>
		</div>
	);
};

export default MobileMenu;
